import { reactive } from 'vue'
import PlannerService from './services/PlannerService'
import i18n from './i18n'
import dayjs from 'dayjs'

const state = reactive({
  customer: {},
  product: {},
  viewingDates: [],
  viewingRequest: {},
  contactDetails: {},
  answers: {},
  settings: {},
  isSigningUpForWaitingList: false,
  waitingListEnabled: false,

  get isSelectionMade () {
    return !!state.viewingRequest.start
  },

  get isValidEmail () {
    const regex = /\S+@\S+\.\S+/
    return regex.test(state.viewingRequest.email_address)
  },

  get futureViewingDates () {
    const now = dayjs()
    return state.viewingDates.filter(date => dayjs(date.end).isAfter(now))
  },

  load (customer, slug) {
    state.viewingRequest.locale = i18n.global.locale

    return PlannerService.load(customer, slug)
      .then((result) => {
        state.waitingListEnabled = true
        Object.assign(state.customer, result.customer)
        Object.assign(state.product, result.product)
        Object.assign(state.viewingDates, result.viewing_dates)
        Object.assign(state.settings, state.customer.viewing_planner_settings)
      })
  },

  storeViewing () {
    state.viewingRequest.contact = state.contactDetails
    state.viewingRequest.answers = state.answers

    return PlannerService.storeViewing(state.viewingRequest)
  },

  storeWaitingListSpot () {
    return PlannerService.storeWaitingListSpot(state.product, state.contactDetails, state.answers)
  },

  select (slot) {
    state.viewingRequest.viewing_date_id = slot.viewing_date_id
    state.viewingRequest.start = slot.start
    state.viewingRequest.end = slot.end
    state.contactDetails = {}
    state.answers = {}

    // Store agenda_item_id for new API if available
    if (slot.agenda_item_id) {
      state.viewingRequest.agenda_item_id = slot.agenda_item_id
    }
  },
  isSelected (slot) {
    return state.viewingRequest.start === slot.start
  }
})

export default state
